import React from 'react';
import jsonLogic from 'json-logic-js';

import {getVariables} from '../../lib/json-logic-utils';
import reducers from './reducers';
import NoDataWidget from '../NoDataWidget';
import LargeWidgetValue from '../LargeWidgetValue';
import Number from '../Number';
import WidgetHeader from '../WidgetHeader';

function SummaryWidget({widget, rows, questions, options, id, formulaDeletedQuestions}) {
  const reducer = new (reducers[widget.aggregation])(rows);
  const values = rows.map(row => {
    const variables = getVariables(row.answers, questions);

    if (widget.filter && !jsonLogic.apply(widget.filter, variables)) {
      // Filter excludes this value, so don't modify it.
      return null;
    }

    return jsonLogic.apply(widget.map, variables);
  }).filter(Boolean);

  if (values.length < 1) {
    return <NoDataWidget id={id} title={widget.title} options={options} question={widget} formulaDeletedQuestions={formulaDeletedQuestions}/>;
  }

  const aggregation = values.reduce(reducer.reduce.bind(reducer), reducer.initialValue());

  return (
    <React.Fragment>
      <WidgetHeader title={widget.title} options={options} id={widget.id} formulaDeletedQuestions={formulaDeletedQuestions}/>
      <LargeWidgetValue><Number>{aggregation}</Number></LargeWidgetValue>
    </React.Fragment>
  );
}

export default SummaryWidget;